export default {
      id: "ELD-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.svg#ELD",
      toString: function () {
        return this.url;
      }
    }